/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * Card network
 */
export type CardNetwork = typeof CardNetwork[keyof typeof CardNetwork];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardNetwork = {
  mastercard: 'mastercard',
} as const;
